// extracted by mini-css-extract-plugin
export default {"cls1":"UserListMenu-cls1_alg","cls2":"UserListMenu-cls2_eM2 UserListMenu-cls1_alg"};